var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDossierLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51021 3.96068C9.57175 5.20409 10.0109 7.41235 11.4516 9.10653C12.5957 10.4538 15.2867 10.8108 16.7581 10.9906C19.3876 11.3123 21.3178 12.8038 21.3178 15.045C21.3178 16.962 19.9835 18.5651 17.6141 19.0386C15.3874 19.4843 13.5244 19.8414 12.1313 20.981C10.8809 22.0066 10.0669 23.5134 9.53259 26.2838C9.08501 28.6111 7.42619 30.0343 5.06523 30.0343C2.70427 30.0343 0.58108 28.2161 0.58108 25.9749C0.58108 23.7337 2.32662 22.1687 4.78549 21.9281C7.87376 21.5938 12.288 19.1576 12.288 15.3109C12.288 11.4642 8.97871 8.9014 4.668 8.10116C2.08046 7.64786 0.547512 6.1892 0.547512 4.05945C0.547512 1.81827 2.556 0 5.03166 0C7.50731 0 9.45146 1.76509 9.51021 3.96068Z",
    fill: "url(#paint0_linear_30_2237)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.213 38.1348C24.8364 38.9204 24.3312 39.7093 23.6515 40.4258C22.2639 41.8878 20.4385 42.7817 18.2101 43.0918C17.2264 43.229 16.3518 42.4446 16.3517 41.4443V41.4414C16.3519 40.6129 16.9583 39.9138 17.7726 39.7979C19.0364 39.6171 20.0775 39.1789 20.8868 38.4922C21.2108 38.6226 21.5457 38.7395 21.8907 38.8398C22.8102 38.7927 23.7554 38.6215 24.7052 38.3145C24.8777 38.2587 25.0464 38.1971 25.213 38.1348ZM25.2345 27.416C25.8219 27.4162 26.2989 27.8972 26.2989 28.4893V33.502C26.2896 33.9514 26.2362 34.7485 26.0314 35.7021C25.4057 35.8194 24.7533 35.8296 24.0753 35.7256C23.5976 35.6523 23.148 35.5321 22.7296 35.3711C23.0306 34.2212 23.0088 33.2891 23.0079 33.2627L23.006 33.1885V30.7354H17.9982C17.0886 30.7353 16.3517 29.9919 16.3517 29.0752C16.3519 28.1586 17.0887 27.4161 17.9982 27.416H25.2345Z",
    fill: "url(#paint1_linear_30_2237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0036 31.0467H23.0093V30.3185H18.0036C17.2759 30.3185 16.6193 29.5534 16.3491 29.127C16.3491 29.3586 16.3491 29.3917 16.3822 29.5903C16.4991 30.2916 17.0896 31.0467 18.0036 31.0467Z",
    fill: "#F08C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0987 28.9186C10.0987 23.5564 14.1946 19.7202 19.7047 19.7202C21.9143 19.7202 23.8589 20.3028 25.3988 21.3929C26.3285 22.0507 26.4034 23.411 25.5687 24.1862C24.9358 24.7739 23.9794 24.8211 23.283 24.3098C22.3076 23.5933 21.1799 23.2262 19.9076 23.2262C16.5957 23.2262 14.2453 25.5643 14.2453 28.9173C14.2453 32.2702 16.597 34.6084 19.9076 34.6084C21.1799 34.6084 22.3088 34.2412 23.283 33.5145C23.9794 32.9969 24.9409 33.0416 25.5776 33.6318C26.411 34.4044 26.3374 35.7583 25.414 36.4213C23.8715 37.5279 21.9156 38.1143 19.6806 38.1143C14.1946 38.1156 10.0987 34.2795 10.0987 28.9186Z",
    fill: "#D500F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0987 28.9186C10.0987 23.5564 14.1946 19.7202 19.7047 19.7202C21.9143 19.7202 23.8589 20.3028 25.3988 21.3929C26.3285 22.0507 26.4034 23.411 25.5687 24.1862C24.9358 24.7739 23.9794 24.8211 23.283 24.3098C22.3076 23.5933 21.1799 23.2262 19.9077 23.2262C16.5957 23.2262 14.2453 25.5643 14.2453 28.9173C14.2453 32.2702 16.597 34.6084 19.9077 34.6084C21.1799 34.6084 22.3088 34.2412 23.283 33.5145C23.9794 32.9969 24.9409 33.0416 25.5776 33.6318C26.411 34.4044 26.3374 35.7583 25.414 36.4213C23.8715 37.5279 21.9156 38.1143 19.6806 38.1143C14.1946 38.1156 10.0987 34.2795 10.0987 28.9186Z",
    fill: "url(#paint2_linear_30_2237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6537 19.7202C21.8631 19.7203 23.8073 20.3032 25.3471 21.3931C26.2768 22.0509 26.3516 23.4109 25.517 24.186C25.416 24.2798 25.3059 24.3582 25.1908 24.4243C23.2881 22.1114 20.5952 20.4727 17.5248 19.9224C18.2049 19.7906 18.9166 19.7202 19.6537 19.7202Z",
    fill: "url(#paint3_linear_30_2237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6584 19.7356C19.8742 19.734 20.0875 19.739 20.2982 19.7485C21.1899 20.7691 21.748 22.0878 21.8024 23.5384C21.7643 23.5255 21.7263 23.5123 21.6879 23.5002C21.1941 23.345 20.6724 23.2581 20.1234 23.242C20.0452 23.2398 19.9664 23.2393 19.8871 23.2399C19.7837 23.2406 19.681 23.2437 19.5795 23.2489C16.4316 23.412 14.2419 25.7242 14.2656 28.9724C14.2671 29.1818 14.278 29.3873 14.2974 29.5884C14.3021 29.6368 14.3084 29.6849 14.3141 29.7328C12.6179 29.3428 11.1888 28.249 10.3559 26.7713C10.3681 26.7171 10.3787 26.6627 10.3918 26.6089C11.3499 22.6783 14.7443 19.9752 19.1458 19.75C19.3152 19.7414 19.4862 19.7368 19.6584 19.7356Z",
    fill: "url(#paint4_linear_30_2237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7556 37.8902C21.9057 37.8581 22.0538 37.8229 22.2002 37.7857C22.9186 36.5909 23.2424 35.1539 23.0315 33.6772C22.4133 34.073 21.7135 34.3429 20.9336 34.4827C17.6736 35.0669 14.9468 33.1799 14.3554 29.8795C14.2924 29.5276 14.2592 29.1822 14.2515 28.8455C12.6215 29.5794 11.4014 30.9733 10.8639 32.6353C12.5169 36.6434 16.6664 38.8091 21.3521 37.9694L21.7556 37.8902Z",
    fill: "url(#paint5_linear_30_2237)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03189 0C7.50743 0.000110011 9.45166 1.76541 9.5104 3.96094C9.51903 4.1351 9.53505 4.32818 9.56021 4.53613C6.89268 4.79742 4.43714 5.78139 2.39224 7.29004C1.20762 6.5649 0.547551 5.45683 0.547512 4.05957C0.547512 1.81839 2.55624 0 5.03189 0Z",
    fill: "url(#paint6_linear_30_2237)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.9858 10.8047C15.5625 10.8745 16.1019 10.9117 16.5363 10.9392C19.2048 11.1088 21.2376 12.4987 21.3693 14.7571C21.4819 16.6887 20.2315 18.3827 17.8721 18.9992C17.167 19.1439 16.4903 19.269 15.8522 19.4046C16.0184 18.2489 16.0725 17.0592 16.0019 15.8478C15.9003 14.1064 15.5483 12.4109 14.9858 10.8047Z",
    fill: "url(#paint7_linear_30_2237)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.5818 10.138C10.5874 10.0129 11.7585 10.0167 13.156 10.2083C13.7593 10.4442 14.418 10.611 15.0447 10.7318C18.256 12.1452 20.6822 15.9772 18.4031 18.8275C18.156 18.9118 17.8945 18.9833 17.6189 19.0384C16.1541 19.3316 14.8471 19.5875 13.7273 20.0521C12.962 19.5736 12.2493 18.7971 11.5798 17.8753C12.0261 17.1118 12.2927 16.2542 12.2927 15.3109C12.2927 13.1553 11.2539 11.403 9.5818 10.138Z",
    fill: "url(#paint8_linear_30_2237)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.03832 9.76684C10.3587 9.72243 11.7549 9.8387 13.0911 10.1877C13.456 10.3338 13.8423 10.4539 14.2307 10.553C17.2627 11.7511 19.6278 16.3118 17.2024 19.1194C15.7953 19.4019 14.5426 19.6707 13.4719 20.1575C12.7281 19.742 12.0587 18.9763 11.4524 18.0608C11.9668 17.2516 12.2805 16.3316 12.2805 15.3108C12.2805 12.9357 11.0184 11.0503 9.03832 9.76684Z",
    fill: "url(#paint9_linear_30_2237)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28716 21.6758C7.56749 21.5869 5.76053 21.6717 4.26829 21.9658C1.35379 22.5401 -0.694788 25.3765 1.29363 28.0953C1.33079 28.1099 1.36701 28.1276 1.40492 28.1417C2.60081 28.5852 3.67605 28.9774 4.57593 29.505C5.3755 29.2575 6.17035 28.6805 6.91924 27.9571C6.63268 27.2192 6.51734 26.4236 6.64985 25.5896C6.92239 23.875 7.89099 22.5661 9.28716 21.6758Z",
    fill: "url(#paint10_linear_30_2237)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03189 30.0342C7.50744 30.0341 9.59326 28.1682 9.652 25.9727C9.65912 25.8289 9.67038 25.6737 9.68521 25.5088C6.96942 25.2664 4.46902 24.2763 2.39224 22.7441C1.20762 23.4693 0.547551 24.5773 0.547512 25.9746C0.547512 28.2158 2.55624 30.0342 5.03189 30.0342Z",
    fill: "url(#paint11_linear_30_2237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_2237",
    x1: 2.69747,
    y1: 4.64196,
    x2: 5.68102,
    y2: 29.1264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_2237",
    x1: 17.3813,
    y1: 29.8412,
    x2: 18.0209,
    y2: 40.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579043,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745243,
    stopColor: "#FD7E02",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA303",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_2237",
    x1: 21.2226,
    y1: 37.2363,
    x2: 18.6703,
    y2: 20.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_2237",
    x1: 40.0095,
    y1: 33.2503,
    x2: 18.6892,
    y2: 14.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_30_2237",
    x1: 8.10706,
    y1: 48.5396,
    x2: 9.36702,
    y2: 19.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#ED772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_30_2237",
    x1: 21.6051,
    y1: 36.4519,
    x2: -6.34597,
    y2: 36.4619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3478ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#65DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#FD7E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_30_2237",
    x1: 0.547512,
    y1: 5.84004,
    x2: 9.54893,
    y2: 4.56871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2960F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#3F8EEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_30_2237",
    x1: 10.2954,
    y1: 10.4583,
    x2: 18.0057,
    y2: 16.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_30_2237",
    x1: 11.8884,
    y1: 11.7746,
    x2: 18.0762,
    y2: 18.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_30_2237",
    x1: 11.2144,
    y1: 11.5486,
    x2: 14.4371,
    y2: 20.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AE5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_30_2237",
    x1: 0.308966,
    y1: 23.6041,
    x2: 5.97261,
    y2: 28.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#F2A73B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_30_2237",
    x1: 10.3008,
    y1: 26.3856,
    x2: 0.550229,
    y2: 25.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#F2A73B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0406,
    height: 18.6897,
    fill: "white",
    transform: "translate(10.0987 19.7202)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossierLogo);
export default __webpack_public_path__ + "static/media/dossier-logo.2179b6a3a2da6ad369fb59694541accb.svg";
export { ForwardRef as ReactComponent };